import { render, staticRenderFns } from "./UnidadeMedidaCadastroModal.vue?vue&type=template&id=3423e672&scoped=true"
import script from "./UnidadeMedidaCadastroModal.vue?vue&type=script&lang=js"
export * from "./UnidadeMedidaCadastroModal.vue?vue&type=script&lang=js"
import style0 from "./UnidadeMedidaCadastroModal.vue?vue&type=style&index=0&id=3423e672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3423e672",
  null
  
)

export default component.exports